export const apiTags = {
	messages: 'messages',
	shop: 'shop',
	contacts: 'contacts',
	chats: 'chats',
	nextBots: 'nextBots',
	grid: 'grid',
	gifts: 'gifts',
	subscriptions: 'subscriptions',
	assignedPromocodes: 'assignedPromocodes',
	imagesGenerationBots: 'imagesGenerationBots',
	imagesGenerationQuota: 'imagesGenerationQuota',
	characterGenerationQuota: 'characterGenerationQuota',
	generatedMedia: 'generatedMedia',
	generatedPublicMedia: 'generatedPublicMedia',
	generatedSimilarMedia: 'generatedSimilarMedia',
	generatedLikedMedia: 'generatedLikedMedia',
	generatedUnlockedMedia: 'generatedUnlockedMedia',
	generatedMediaById: 'generatedMediaById',
	tags: 'tags',
	userProps: 'userProps',
	userConfig: 'userConfig',
	videosGenerationBots: 'videosGenerationBots',
	videosGenerationQuota: 'videosGenerationQuota',
	liveops: 'liveops',
	botGallery: 'botGallery',
	suggestedTexts: 'suggestedTexts',
};
